import apiClient from '@/services/axios'
import config from '@/configs'

// * customers functions
// search all customers
export async function searchCustomers(search) {
  return apiClient
    .get(`${config.api.crm.customers_search}/${search}`)
    .then((res) => (res && res.data ? res.data : null))
    .catch((err) => console.error('[CRM/Customers API]:', err))
}

// get customers by query
export async function fetchCustomers(query) {
  return apiClient
    .post(`${config.api.crm.customers}/query`, query)
    .then((res) => (res && res.data ? res.data : null))
    .catch((err) => console.error('[CRM/Customers API]:', err))
}

// get a customer by id
export async function fetchCustomer(id) {
  return apiClient
    .get(`${config.api.crm.customers}/${id}`)
    .then((res) => (res && res.data ? res.data : null))
    .catch((err) => console.error('[CRM/Customers API]:', err))
}

// get customer histories by customer id
export async function fetchHistory(id) {
  return apiClient
    .get(`${config.api.crm.customers}/${id}/history`)
    .then((res) => (res && res.data ? res.data : null))
    .catch((err) => console.error('[CRM/Customers API]:', err))
}

// insert the history by customer id
export async function insertHistory(id, content) {
  return apiClient
    .post(`${config.api.crm.customers}/${id}/history`, {
      type: 'user_record',
      content: content,
    })
    .then((res) => (res && res.data ? res.data : null))
    .catch((err) => console.error('[CRM/Customers API]:', err))
}

// create a new customer
export async function createCustomer(customer) {
  return apiClient
    .post(config.api.crm.customers, customer)
    .then((res) => (res && res.data ? res.data : null))
    .catch((err) => console.error('[CRM/Customers API]:', err))
}

// update a customer
export async function updateCustomer(customer) {
  return apiClient
    .put(config.api.crm.customers, customer)
    .then((res) => (res && res.data ? res.data : null))
    .catch((err) => console.error('[CRM/Customers API]:', err))
}
